import { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_USER_LOGIN } from "../Schema/User";

export const useGetUserLogin = () => {
  const { refetch, data } = useQuery(GET_USER_LOGIN, {
    onCompleted: ({ getUserLogin }) => {
      setTimeout(() => {
        const token = JSON.stringify(getUserLogin?.token);
        const user = JSON.stringify(getUserLogin?.user);

        // window.localStorage.setItem("token", token);
        // window.localStorage.setItem("userLogin", user);

        // if (
        //   ["Invalid signature!", "invalid signature", "Unauthorized!"].includes(
        //     getUserLogin?.message?.messageEn
        //   )
        // ) {
        //   window.localStorage.clear();
        //   window.location.reload();
        // }
      }, 20000);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    refetch();
  }, []);

  return { refetch, data: data?.getUserLogin?.user };
};
